import { render, staticRenderFns } from "./DeliveryLogin.vue?vue&type=template&id=939ef2ce&scoped=true&"
import script from "./DeliveryLogin.vue?vue&type=script&lang=js&"
export * from "./DeliveryLogin.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLogin.vue?vue&type=style&index=0&id=939ef2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939ef2ce",
  null
  
)

export default component.exports